
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'LoginLayout',
})
export default class Main extends Vue {
}
